export enum ColumnType {
    Unknown = 0,
    Text = 1,
    CheckBox = 2,
    DropDownList = 3,
    RadioButton = 4,
    ImageSelector = 5,
    Slider = 6,
    NumericAnswer = 7,
    StarRating = 8,
}
